import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-type-filter',
  templateUrl: './type-filter.component.html',
  styleUrls: ['./type-filter.component.scss']
})
export class TypeFilterComponent implements OnInit {
  @Input() public typesFilter: string[];
  @Output() public filters = new EventEmitter<string[]>();

  public filtersDefs = [
    { name: 'image', title: 'Images', icon: 'file-image' },
    { name: 'document', title: 'Documents', icon: 'file-pdf' },
    { name: 'video', title: 'Videos', icon: 'file-video' },
    { name: 'audio', title: 'Podcasts', icon: 'file-audio' },
    { name: 'folder', title: 'Folder', icon: 'folder' }
  ];

  constructor() {}

  public ngOnInit() {}

  public filterIncludes(type: string) {
    return this.typesFilter.length == 0 || this.typesFilter.includes(type);
  }

  public updateFilter(type: string) {
    if (this.typesFilter.length == 0) {
      this.typesFilter = this.filtersDefs.map(f => f.name).filter(t => t !== type);
    } else if (this.typesFilter.includes(type)) {
      this.typesFilter = this.typesFilter.filter(t => t !== type);
    } else {
      this.typesFilter.push(type);
    }
    this.filters.emit([...this.typesFilter]);
  }
}
